export enum TextsTodo {
    RECORD = 'record',
    TRANSLATE = 'translate'
}
